import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // Not logged in → redirect to /admin login page
    return <Navigate to="/admin" replace />;
  }

  // Logged in → allow access
  return children;
}
